module.exports = __webpack_public_path__ + "img/mile6.e3824db1.jpg";